import React from 'react';
import { ReactComponent as BlueUpArrowIcon } from 'src/assets/blue-up-arrow-icon.svg';

const BlueDownArroIcon: React.FC = () => {
  return <BlueUpArrowIcon style={{ transform: 'rotate(180deg)' }} />;
};

export default BlueDownArroIcon;
